module.exports = __webpack_public_path__ + "img/menu-3.92800c07.svg";